var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTankLevelManagementDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 46,
    viewBox: "0 0 44 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 7H11C10.4477 7 10 7.44772 10 8V38C10 38.5523 10.4477 39 11 39H27C27.5523 39 28 38.5523 28 38V8C28 7.44772 27.5523 7 27 7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 12.8293C26.6872 12.9398 26.3506 13 26 13H5C4.64936 13 4.31278 12.9398 4 12.8293M27 12.8293C28.1652 12.4175 29 11.3062 29 10C29 8.34315 27.6569 7 26 7H5C3.34315 7 2 8.34315 2 10C2 11.3062 2.83481 12.4175 4 12.8293M27 12.8293V20.1707M4 12.8293V20.1707M27 20.1707C26.6872 20.0602 26.3506 20 26 20H5C4.64936 20 4.31278 20.0602 4 20.1707M27 20.1707C28.1652 20.5825 29 21.6938 29 23C29 24.3062 28.1652 25.4175 27 25.8293M4 20.1707C2.83481 20.5825 2 21.6938 2 23C2 24.3062 2.83481 25.4175 4 25.8293M27 25.8293C26.6872 25.9398 26.3506 26 26 26H5C4.64936 26 4.31278 25.9398 4 25.8293M27 25.8293V33.1707M4 25.8293V33.1707M27 33.1707C28.1652 33.5825 29 34.6938 29 36C29 37.6569 27.6569 39 26 39H5C3.34315 39 2 37.6569 2 36C2 34.6938 2.83481 33.5825 4 33.1707M27 33.1707C26.6872 33.0602 26.3506 33 26 33H5C4.64936 33 4.31278 33.0602 4 33.1707",
    stroke: "#92A1B6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 9H40.5V13.5M40.5 13.5H37M40.5 13.5V18M40.5 18H34M40.5 18V23M40.5 23H37M40.5 23V28M40.5 28H34M40.5 28V33M40.5 33V38H34M40.5 33H37",
    stroke: "#92A1B6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTankLevelManagementDisabled);
export default __webpack_public_path__ + "static/media/icon-tank-level-management-disabled.e3f049fb768cae77d793e91f2b134301.svg";
export { ForwardRef as ReactComponent };